export default "__VITE_ASSET__c86fff19__"